import PropTypes from 'prop-types';
import React from 'react';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const defaultMaskOptions = {
  suffix: '',
  includeThousandsSeparator: true,
  allowDecimal: true,
  decimalLimit: 2,
  integerLimit: 3,
  requireDecimal: false,
  allowNegative: false,
  allowLeadingZeroes: true,
};

function CurrencyInput({
  i18n,
  language,
  maskOptions,
  inputMode,
  ...inputProps
}) {
  const currencyMask = createNumberMask({
    ...defaultMaskOptions,
    ...maskOptions,
    prefix: `${i18n.currency?.symbol} `,
    thousandsSeparatorSymbol: language?.symbol?.thousands,
    decimalSymbol: language?.symbol?.decimal,
  });

  return (
    <MaskedInput mask={currencyMask} inputMode="decimal" {...inputProps} />
  );
}

CurrencyInput.defaultProps = {
  maskOptions: {},
};

CurrencyInput.propTypes = {
  maskOptions: PropTypes.shape({
    prefix: PropTypes.string,
    suffix: PropTypes.string,
    includeThousandsSeparator: PropTypes.bool,
    thousandsSeparatorSymbol: PropTypes.string,
    allowDecimal: PropTypes.bool,
    decimalSymbol: PropTypes.string,
    decimalLimit: PropTypes.string,
    requireDecimal: PropTypes.bool,
    allowNegative: PropTypes.bool,
    allowLeadingZeroes: PropTypes.bool,
    integerLimit: PropTypes.number,
  }),
};

export default CurrencyInput;
